import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useTeamMedianTrietia = (teamId: string | undefined) => {
  return useQuery<number | null>({
    queryKey: ['team-median-trietia', teamId],
    queryFn: async (): Promise<number | null> => {
      if (!teamId) return null;

      // Get all team members
      const { data: members, error: membersError } = await supabase
        .from('team_members')
        .select('profile_id')
        .eq('team_id', teamId);

      if (membersError) throw membersError;
      if (!members || members.length === 0) return null;

      // Get trietia for all members
      const { data: profiles, error: profilesError } = await supabase
        .from('profiles')
        .select('trietia')
        .in('id', members.map((m: any) => m.profile_id))
        .not('trietia', 'is', null);

      if (profilesError) throw profilesError;
      if (!profiles || profiles.length === 0) return null;

      // Calculate median
      const trietiaValues = profiles.map((p: any) => p.trietia).sort((a: number, b: number) => a - b);
      const mid = Math.floor(trietiaValues.length / 2);
      
      const median = trietiaValues.length % 2 === 0
        ? (trietiaValues[mid - 1] + trietiaValues[mid]) / 2
        : trietiaValues[mid];

      return median;
    },
    enabled: !!teamId,
  });
};

